import { useEffect, useState } from "react";
import classNames from "classnames";
import { useKeenSlider } from "keen-slider/react";
import { SpriteIcon } from "@shared/ui/SpriteIcon";
import { SLIDES_INSTRUCTION } from "./config";
import { INSTRUCTION_VIEWED_KEY } from "./constants";
import classes from "./show-instruction.module.scss";

export const ShowInstruction = () => {
    const [open, setOpen] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);

    const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
        loop: false,
        slides: {
            perView: 1
        },
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        }
    });

    const toggleOpen = () => setOpen((prev) => !prev);

    const handlePrev = () => {
        instanceRef.current?.prev();
    };

    const handleNext = () => {
        instanceRef.current?.next();
    };

    const isFirstSlide = currentSlide === 0;
    const isLastSlide = currentSlide === SLIDES_INSTRUCTION.length - 1;

    useEffect(() => {
        if (typeof window !== "undefined") {
            const alreadyViewed = localStorage.getItem(INSTRUCTION_VIEWED_KEY);
            if (!alreadyViewed) {
                setOpen(true);
                localStorage.setItem(INSTRUCTION_VIEWED_KEY, "true");
            }
        }
    }, []);

    return (
        <>
            <button
                className={classes["show-instruction"]}
                title="Показать инструкцию"
                onClick={toggleOpen}
            >
                ?
            </button>
            <div
                className={classNames(classes["show-instruction__slider"], {
                    [classes["show-instruction__slider--visible"]]: open
                })}
            >
                <div className="keen-slider" ref={sliderRef}>
                    {SLIDES_INSTRUCTION.map((slide, index) => (
                        <div
                            key={index}
                            className={classNames(
                                "keen-slider__slide",
                                classes["show-instruction__slide"]
                            )}
                        >
                            <div className={classes["show-instruction__content"]}>
                                <p className={classes["show-instruction__title"]}>{slide.title}</p>
                                {slide?.sample}
                                {slide.content && (
                                    <div className={classes["show-instruction__text"]}>
                                        {slide.content}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                <div className={classes["show-instruction__tabs"]}>
                    {SLIDES_INSTRUCTION.map((slide, index) => (
                        <span
                            key={index}
                            className={classNames(classes["show-instruction__tab"], {
                                [classes["show-instruction__tab--active"]]: currentSlide === index
                            })}
                            onClick={() => instanceRef.current?.moveToIdx(index)}
                        >
                            {slide.tag}
                        </span>
                    ))}
                </div>
                <button
                    className={classNames(
                        classes["show-instruction__nav"],
                        classes["show-instruction__nav--left"]
                    )}
                    title="Предыдущий слайд"
                    onClick={handlePrev}
                >
                    <SpriteIcon
                        className={classNames(classes["show-instruction__arrow"], {
                            [classes["show-instruction__arrow--disabled"]]: isFirstSlide
                        })}
                        section={"common"}
                        name={"arrow"}
                    />
                </button>
                <button
                    className={classNames(
                        classes["show-instruction__nav"],
                        classes["show-instruction__nav--right"]
                    )}
                    title="Следующий слайд"
                    onClick={handleNext}
                >
                    <SpriteIcon
                        className={classNames(
                            classes["show-instruction__arrow"],
                            classes["show-instruction__arrow--right"],
                            { [classes["show-instruction__arrow--disabled"]]: isLastSlide }
                        )}
                        section={"common"}
                        name={"arrow"}
                    />
                </button>
                <button
                    title="Закрыть инструкцию"
                    className={classes["show-instruction__close"]}
                    onClick={toggleOpen}
                >
                    <SpriteIcon
                        className={classes["show-instruction__close--icon"]}
                        section={"common"}
                        name={"close"}
                    />
                </button>
            </div>
        </>
    );
};